import React from 'react';
import { PayoutResult } from '../../types/payout';

interface PayoutResultsProps {
  results: PayoutResult;
}

export function PayoutResults({ results }: PayoutResultsProps) {
  if (!results) return null;

  const {
    policyLimit,
    mode,
    triggeredDays,
    totalPayout,
    avgAnnualLoss,
    details
  } = results;

  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold">Payout Results</h4>
      <table className="data-grid w-full">
        <tbody>
          <tr>
            <td className="font-medium">Policy Limit</td>
            <td>${policyLimit.toLocaleString()}</td>
          </tr>
          <tr>
            <td className="font-medium">Mode</td>
            <td>{mode}</td>
          </tr>
          <tr>
            <td className="font-medium">Triggered Days</td>
            <td>{triggeredDays}</td>
          </tr>
          <tr>
            <td className="font-medium">Total Payout</td>
            <td>${totalPayout.toLocaleString()}</td>
          </tr>
          <tr>
            <td className="font-medium">Avg Annual Loss (5 yrs)</td>
            <td>${avgAnnualLoss.toLocaleString()}</td>
          </tr>
        </tbody>
      </table>

      {details.length > 0 && (
        <>
          <h4 className="text-lg font-semibold mt-4">Triggered Details</h4>
          <table className="data-grid w-full">
            <thead>
              <tr>
                <th>Location</th>
                <th>Day</th>
                <th>Value</th>
                <th>Payout</th>
              </tr>
            </thead>
            <tbody>
              {details.map((detail, index) => (
                <tr key={index}>
                  <td>{detail.location}</td>
                  <td>{detail.day}</td>
                  <td>{detail.value.toFixed(2)}</td>
                  <td>${detail.payout.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}